import { fetchWithRetryForDirectCalls } from "./retryFetch";
import { getApiBase, getOnboardingFetchHeaders } from "./apiRequestHeaders";

const ONBOARDING_BASE = () => `${getApiBase()}/user/onboarding-state`;

export interface OnboardingState {
  language_selection_shown: boolean;
  sound_selection_shown: boolean;
  onboarding_sound_prompt_done: boolean;
  sounds_enabled: boolean | null;
  i18next_lng: string | null;
  user_manually_selected_language: boolean;
  tap_onboarding_month: string | null;
  map_onboarding_month: string | null;
  map_welcome_month: string | null;
  map_welcome_started_at_ms: number | null;
  /** З рядка User на бекенді (не KV). True = пройшов онбординг + отримав нагороду. */
  onboarding_completed: boolean;
  write_access_last_prompted_at_ms: number | null;
  write_access_post_map_prompt_done: boolean;
  zoom_hint_shown: boolean;
  /** Interior tutorial: its major step, or "done" / "skipped" (domain/interiorTutorial). */
  interior_onboarding?: string | null;
  /** The quests screen was opened at least once; until then the map button glows. */
  quests_opened?: boolean;
}

export async function fetchOnboardingStateFromServer(): Promise<OnboardingState> {
  const res = await fetchWithRetryForDirectCalls(ONBOARDING_BASE(), {
    method: "GET",
    headers: getOnboardingFetchHeaders(),
  });
  if (!res.ok) {
    const t = await res.text();
    throw new Error(`onboarding-state GET ${res.status}: ${t}`);
  }
  return (await res.json()) as OnboardingState;
}

export async function patchOnboardingStateOnServer(
  patch: Partial<OnboardingState>
): Promise<void> {
  const keys = Object.keys(patch);
  if (keys.length === 0) return;
  const res = await fetchWithRetryForDirectCalls(ONBOARDING_BASE(), {
    method: "PATCH",
    headers: getOnboardingFetchHeaders(),
    body: JSON.stringify(patch),
  });
  if (!res.ok) {
    const t = await res.text();
    throw new Error(`onboarding-state PATCH ${res.status}: ${t}`);
  }
}

export async function deleteOnboardingStateOnServer(): Promise<void> {
  const res = await fetchWithRetryForDirectCalls(ONBOARDING_BASE(), {
    method: "DELETE",
    headers: getOnboardingFetchHeaders(),
  });
  if (!res.ok) {
    const t = await res.text();
    throw new Error(`onboarding-state DELETE ${res.status}: ${t}`);
  }
}
